import { render, staticRenderFns } from "./async-multi-select.vue?vue&type=template&id=2927a8fc"
import script from "./async-multi-select.vue?vue&type=script&lang=js"
export * from "./async-multi-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports